import { render, staticRenderFns } from "./PlanTable.vue?vue&type=template&id=b2d8edf2&scoped=true"
import script from "./PlanTable.vue?vue&type=script&lang=js"
export * from "./PlanTable.vue?vue&type=script&lang=js"
import style0 from "./PlanTable.vue?vue&type=style&index=0&id=b2d8edf2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2d8edf2",
  null
  
)

export default component.exports